import React from 'react';
import clsx from 'clsx';

const LoadingDots = ({ className = '' }) => {
  return (
    <div className={clsx('flex items-center justify-center gap-2', className)}>
      <div className="h-5 w-5 bg-primary rounded-full animate-[scale_1.2s_ease-in-out_infinite]" />
      <div className="h-5 w-5 bg-primary rounded-full animate-[scale_1.2s_ease-in-out_0.4s_infinite]" />
      <div className="h-5 w-5 bg-primary rounded-full animate-[scale_1.2s_ease-in-out_infinite]" />
    </div>
  );
};

export default LoadingDots;
